import Error from '../views/app/Error.vue'

export default [
    {
        path: '/error/:statusCode',
        name: 'error',
        component: Error,
        props: true,
        meta: { title: 'Fehler' }
    },
    {
        path: '*',
        name: 'not-found',
        redirect: { name: 'error', params: { statusCode: 404 } }
    }
]
